import { readCookieConsent } from './cookieConsent';

const MATOMO_URL = process.env.REACT_APP_MATOMO_URL || 'https://bongoslcs.matomo.cloud/';
const MATOMO_SITE_ID = process.env.REACT_APP_MATOMO_SITE_ID || '1';
const MATOMO_SCRIPT_URL = process.env.REACT_APP_MATOMO_SCRIPT_URL || '';

function normalizeMatomoBaseUrl(url) {
  const trimmed = String(url || '').trim();
  if (!trimmed) return '';
  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
}

function resolveMatomoScriptUrl(baseUrl) {
  if (MATOMO_SCRIPT_URL) return MATOMO_SCRIPT_URL;
  try {
    const host = new URL(baseUrl).host;
    if (host.endsWith('.matomo.cloud')) {
      return `https://cdn.matomo.cloud/${host}/matomo.js`;
    }
  } catch {
    /* ignore */
  }
  return `${baseUrl}matomo.js`;
}

export function isMatomoConfigured() {
  const base = normalizeMatomoBaseUrl(MATOMO_URL);
  const siteId = String(MATOMO_SITE_ID || '').trim();
  return Boolean(base && siteId && /^https:\/\//i.test(base));
}

export function getMatomoHost() {
  if (!MATOMO_URL) return '';
  try {
    return new URL(normalizeMatomoBaseUrl(MATOMO_URL)).host;
  } catch {
    return '';
  }
}

export function isMatomoTrackingAllowed() {
  return isMatomoConfigured() && readCookieConsent() === 'accepted';
}

function getPaq() {
  if (typeof window === 'undefined') return null;
  window._paq = window._paq || [];
  return window._paq;
}

export function initMatomo() {
  if (!isMatomoTrackingAllowed() || window.__matomoInitialized) return false;

  const baseUrl = normalizeMatomoBaseUrl(MATOMO_URL);
  const siteId = String(MATOMO_SITE_ID).trim();
  const paq = getPaq();
  if (!paq) return false;

  paq.push(['setTrackerUrl', `${baseUrl}matomo.php`]);
  paq.push(['setSiteId', siteId]);
  paq.push(['enableLinkTracking']);

  const script = document.createElement('script');
  script.async = true;
  script.src = resolveMatomoScriptUrl(baseUrl);
  script.dataset.matomoTracker = 'true';
  document.head.appendChild(script);

  window.__matomoInitialized = true;
  return true;
}
export function trackMatomoPageView(pagePath, pageTitle) {
  if (!isMatomoTrackingAllowed()) return;

  if (!window.__matomoInitialized) {
    initMatomo();
  }

  const paq = getPaq();
  if (!paq) return;

  const path = pagePath || `${window.location.pathname}${window.location.search}`;
  const title = pageTitle || document.title;

  paq.push(['setCustomUrl', path]);
  paq.push(['setDocumentTitle', title]);
  paq.push(['trackPageView']);
}
